import React from 'react';

import { colors } from 'app/variables';
import Button from 'app/commonComponents/Button';

function ActionButton({ children, ...rest }) {
  return (
    <Button hollow color={colors.pacificBlue} {...rest}>
      {children}
    </Button>
  );
}

ActionButton.propTypes = Button.propTypes;

export default ActionButton;
